module.exports = __webpack_public_path__ + "img/mainhome.e542251b.png";